<template>
  <div class="w-100 my-5">
    <div v-if="couponList">
      <div class="row my-5" v-if="(items.length > 0)">
        <div :class="`col-sm${colSmSize}`" v-for="(item, index) in items" :key="(item, index)">
          <div class="my-2 box-white d-flex flex-column">
            <span class="mt-2 ellipsis font-bold font-16">{{ `${$t('event')} : ${getEventName(item.eventId)}` }}</span>
            <span class="mt-2 ellipsis font-bold font-16">{{ `${$t('coupon_code')} : ${item.couponCode}` }}</span>
            <div class="my-2 vertical-center">
              <span class="ellipsis font-15 font-bold color-red">{{ `${$t('percent')} : ${item.percent}%` }}</span>
            </div>
            <div class="my-2 vertical-center">
              <span class="font-15 color-blue">{{ `${$t('total_quantity')} : ${item.totalQuantity}` }},</span>
              <span class="ml-2 font-15 color-blue">{{ `${$t('used_quantity')} : ${item.usedQuantity}` }}</span>
            </div>
            <span class="mt-2 ellipsis font-bold font-16">{{ `${$t('influencer')} : ${getInfluencers(item.influencerList)}` }}</span>
          </div>
        </div>
      </div>
      <div class="py-40 center" v-else>
        <span class="font-20 alpha-07">{{ $t('no_data_found') }}</span>
      </div>
    </div>
    <div class="py-40 center" v-else>
      <p>{{ $t('please_wait') }}</p>
      <b-spinner type="grow"></b-spinner>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CouponList',
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    colSmSize() {
      return this.$store.state.colSmSize;
    },
    couponList() {
      return this.$store.state.couponList;
    },
    userList() {
      if (this.$store.state.userList) {
        return this.$store.state.userList.filter(element => element.userType === 2);
      } else {
        return [];
      }
    },
    eventList() {
      return this.$store.state.eventList || [];
    },
  },
  watch: {
    couponList() {
      this.refreshData();
    }
  },
  data() {
    return {
      items: []
    }
  },
  mounted() {
    this.refreshData();
  },
  methods: {
    refreshData() {
      if (this.couponList) {
        this.items = this.couponList.filter(element => element.influencerList && element.influencerList.includes(this.$route.params.influencerId));
      }
    },
    getEventName(eventId) {
      const index = this.eventList.findIndex(element => element.eventId === eventId);
      if (index >= 0 && index < this.eventList.length) {
        return this.eventList[index].name;
      } else {
        return '-';
      }
    },
    getInfluencers(influencerList) {
      var influencers = '';
      if (influencerList) {
        influencerList.forEach(id => {
          const index = this.userList.findIndex(element => element.userId === id);
          if (index >= 0 && index < this.userList.length) {
            const influencerInfo = this.userList[index];
            if (influencers) {
              influencers += ', ';
            }
            influencers += influencerInfo.userName;
          }
        });
      }
      return influencers;
    },
  }
};
</script>
